export enum DIALOG_TYPE {
    reject = 'reject',
    edit = 'edit',
}

export const VERIFICATION_DIGITS_LENGTH = 4;
